module.exports = __webpack_public_path__ + "static/media/AdmisionesNormales.d8845818.svg";